<template>
    <div class="text-unfold" :class="{ unfold }" v-watchResize="{
        handler: handleResize,
        spaceAfter: 8
    }" :style="{ '-webkit-line-clamp': lineClamp }">
        <div class="place" :style="{ height: placeHeight }" />
        <div class="icon" v-show="iconVisible" @click="handleUnfold"
            :style="[{ width: `${lineHeight}px` }, { height: `${lineHeight}px` }]">
            <span></span>
        </div>
        {{ computedValue }}
    </div>
</template>

<script>
export default {
    name: 'TextUnfold',
    props: {
        frontSpace: {
            type: Number,
            default: 0,
        },
        lineClamp: {
            type: Number,
            default: 3,
        },
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        computedValue() {
            let front = ''
            for (let index = 0; index < this.frontSpace; index++) {
                front += String.fromCharCode(160)
            }
            return `${front}${this.value}`
        },
        iconVisible() {
            const lines = Math.floor((this.textHeight) / this.lineHeight)
            return lines > this.lineClamp
        },
        placeHeight() {
            let result = 'auto'
            if (this.unfold) {
                const lines = Math.floor(this.textHeight / this.lineHeight)
                result = `${this.lineHeight * (lines - 1)}px`
            } else {
                result = `${this.lineHeight * (this.lineClamp - 1)}px`
            }
            return result
        },
    },
    data() {
        return {
            unfold: false,
            lineHeight: 0,
            textHeight: 0,
        }
    },
    methods: {
        handleUnfold() {
            this.unfold = !this.unfold
        },
        handleResize(val) {
            const { textHeight, lineHeight } = val
            this.textHeight = textHeight
            this.lineHeight = lineHeight
        },
    }
}
</script>

<style lang="scss" scoped>
.text-unfold {
    position: relative;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    text-align: justify;
    text-overflow: ellipsis;
    word-break: break-all;

    .place {
        float: right;
        width: 0;
        height: 48px;
    }

    .icon {
        display: flex;
        float: right;
        clear: both;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        margin: 0 0 0 20px;
        cursor: pointer;

        span {
            width: 18px;
            height: 18px;
            transition: all 0.2s;
            background-color: #838da6;
            mask-image: url(~@/assets/images/ai_write/ai_write-arrow.svg);
            mask-size: 150%;
            mask-position: center center;

            &:hover {
                background-color: #4e4b69;
            }
        }
    }

    &.unfold {
        display: block;
        -webkit-line-clamp: initial !important;

        .icon {
            span {
                transform: rotate(180deg);
            }
        }
    }
}
</style>